// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3IG6m","center":"Logo_center__Ea-u8","withText":"Logo_withText__2l48P"};